import { canUseDOM } from 'exenv';
import set from 'lodash/set';
import get from 'lodash/get';
import asyncTagPageAction from '../../../../redux/actions/tag/async_tag_page_actions';
import log from '../../../../services/logger_service';
import podcasts from '../../../../config/podcast_config';

export default function fetchDataWithStore(store, override) {
  return function fetchData(nextState, replace, callback) {
    const { dispatch } = store;
    const podcast = get(nextState, 'params.podcast', false);

    if (override) {
      if (override !== 'magazine') {
        set(nextState, 'params.tag', override); // eslint-disable-next-line no-param-reassign
      } else {
        set(nextState, 'params.magazine', true);
      }
    }

    podcasts.forEach(pod => {
      // console.log('Podcast == podslug', podcast, pod.slug);
      if (podcast === pod.slug) {
        // console.log('setting nexState to', pod.tag);
        set(nextState, 'params.tag', pod.tag); // eslint-disable-next-line no-param-reassign
      }
    });
    // switch (podcast) {
    //   case 'creative-conversation':
    //     set(nextState, 'params.tag', 'creative conversation podcast'); // eslint-disable-next-line no-param-reassign
    //     break;
    //   case 'secrets-of-the-most-productive-people':
    //     set(
    //       nextState,
    //       'params.tag',
    //       'Secrets of the Most Productive People podcast'
    //     ); // eslint-disable-next-line no-param-reassign
    //     break;
    //   default:
    //     break;
    // }
    // run async
    if (canUseDOM) {
      if (store.getState().config.initialPageLoad === true) {
        if (callback) {
          return callback();
        }
        return false;
      }
      asyncTagPageAction(nextState.params, store)(dispatch);
      if (callback) {
        return callback();
      }
      return false;
    }
    // run sync
    return asyncTagPageAction(nextState.params, store)(dispatch)
      .then(function cb() {
        if (callback) {
          return callback();
        }
        return false;
      })
      .catch(function handleActionError(error) {
        log.fatal(
          error,
          `Fatal error in onEnter state manager: ${error.message}`
        );
        if (callback) {
          return callback(error);
        }
        return false;
      });
  };
}
